export default __webpack_public_path__ + "static/app-access-832a73d663e5c02f7b7b75d186956343.png";